import { useMutation, useQueryClient } from "@tanstack/react-query";
import { QueryKeys } from "../QueryKeys";
import { useApi } from "../useApi";

export const useUpdatePrescription = (
  treatmentId: string,
  app: "care" | "portal",
) => {
  const { api } = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (file: File) => api.treatment.updatePrescription(treatmentId, file, app),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QueryKeys.fetchTreatmentSummary, treatmentId],
      });
      queryClient.invalidateQueries({
        queryKey: [QueryKeys.fetchPrescriptionUrls, treatmentId],
      });
      if (app === "care") {
        queryClient.invalidateQueries({
          queryKey: [QueryKeys.fetchActiveTreatment],
        });
      }
    },
  });
};
